import { pages } from 'constants/urls';
import { trackingParams } from 'constants/queryParams';
import { pushData, pushEvent } from '@nykaa/data-layer/utils';
import { TOP_INAPP_CLICKED } from 'constants/kebabMenu';
import { cartViewLocation, locationPathname } from 'constants/dataLayer';

export interface GamoogaParams {
  GAMOOGA_NOTIFICATION_UTM_SOURCE: string;
  GAMOOGA_NOTIFICATION_UTM_MEDIUM: string;
  GAMOOGA_NOTIFICATION_UTM_CAMPAIGN: string;
  cp_id?: string;
}
export interface GamoogaNotificationProps {
  str: string;
  params: GamoogaParams;
}

export interface GamoogaProps {
  gamoogaCartNotification: GamoogaNotificationProps | null;
  cartViewLocation?: string;
  pageSource?: string;
}

const GAMOOGA_NOTIFICATION_VIEW = 'web_calllback_view';

const GAMOOGA_NOTIFICATION_CLICK = 'web_calllback_click';

export const addWindowHandler = (callBack: (arg0: any) => void) => {
  window.handleGamoogaCartNotification = (str: string, obj: any) => {
    if (typeof str !== 'string' && typeof obj !== 'object') {
      return;
    }
    const {
      GAMOOGA_NOTIFICATION_NOTIFICATION_DISPLAY_TIME_IN_SEC,
      GAMOOGA_NOTIFICATION_NOTIFICATION_ADDITIONAL_DISPLAY_TIME_IN_SEC,
      ...params
    } = obj;

    const {
      GAMOOGA_NOTIFICATION_UTM_SOURCE,
      GAMOOGA_NOTIFICATION_UTM_MEDIUM,
      GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
      cp_id,
    } = params || {};
    if (typeof callBack === 'function') {
      if (Object.keys(params).length > 0) {
        pushData({
          event: GAMOOGA_NOTIFICATION_VIEW,
          gamoogaNotification: {
            utmSource: GAMOOGA_NOTIFICATION_UTM_SOURCE,
            utmMedium: GAMOOGA_NOTIFICATION_UTM_MEDIUM,
            utmCampaign: GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
            cpid: cp_id,
          },
        });
      }
      callBack({ str, params });
    }
    const milliSeconds =
      (GAMOOGA_NOTIFICATION_NOTIFICATION_DISPLAY_TIME_IN_SEC +
        GAMOOGA_NOTIFICATION_NOTIFICATION_ADDITIONAL_DISPLAY_TIME_IN_SEC) *
      1000;
    setTimeout(() => {
      if (typeof callBack === 'function') {
        callBack(null);
      }
    }, milliSeconds);
  };
};

export const handleCartNotificationOnclick = ({
  gamoogaCartNotification,
  cartViewLocation,
  pageSource,
}: GamoogaProps) => {
  const { params } = gamoogaCartNotification || {};
  const {
    GAMOOGA_NOTIFICATION_UTM_SOURCE,
    GAMOOGA_NOTIFICATION_UTM_MEDIUM,
    GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
    cp_id,
  } = params || {};
  let url = pages.CHECKOUT_PAGE;
  const trackParams = [];
  if (GAMOOGA_NOTIFICATION_UTM_SOURCE) {
    trackParams.push(
      `${trackingParams.UTM_SOURCE}=${GAMOOGA_NOTIFICATION_UTM_SOURCE}`
    );
  }
  if (GAMOOGA_NOTIFICATION_UTM_MEDIUM) {
    trackParams.push(
      `${trackingParams.UTM_MEDIUM}=${GAMOOGA_NOTIFICATION_UTM_MEDIUM}`
    );
  }
  if (GAMOOGA_NOTIFICATION_UTM_CAMPAIGN) {
    trackParams.push(
      `${trackingParams.UTM_CAMPAIGN}=${GAMOOGA_NOTIFICATION_UTM_CAMPAIGN}`
    );
  }
  if (cartViewLocation) {
    trackParams.push(`${trackingParams.REDIRECTION_FROM}=${cartViewLocation}`);
  }
  if (pageSource) {
    trackParams.push(`${trackingParams.PAGE_SOURCE}=${pageSource}`);
  }
  if (trackParams.length > 0) {
    pushData({
      event: GAMOOGA_NOTIFICATION_CLICK,
      gamoogaNotification: {
        utmSource: GAMOOGA_NOTIFICATION_UTM_SOURCE,
        utmMedium: GAMOOGA_NOTIFICATION_UTM_MEDIUM,
        utmCampaign: GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
        cpid: cp_id,
      },
    });
    const inappEventData = `${GAMOOGA_NOTIFICATION_UTM_SOURCE}:${GAMOOGA_NOTIFICATION_UTM_MEDIUM}:${GAMOOGA_NOTIFICATION_UTM_CAMPAIGN}`;
    pushEvent(TOP_INAPP_CLICKED, {
      top_inapp_clicked_value_hit: inappEventData,
    });
    url += `?${trackParams.join('&')}`;
  }
  window.location.href = url;
};

const getPageSource = (
  mapping: Record<string, string>,
  defaultSource: string
) => {
  if (__SERVER__ || !window?.location) return defaultSource;

  const { pathname } = window.location;

  let source = '';

  if (pathname === locationPathname.HOME) {
    source = cartViewLocation.HOME_PAGE;
  } else {
    source =
      Object.entries(mapping).find(([key]) => pathname.includes(key))?.[1] ||
      defaultSource;
  }

  return source;
};

export const getCartViewLocation = () =>
  getPageSource(
    {
      [locationPathname.PLP]: cartViewLocation.PLP_TOP_NAV,
      [locationPathname.PDP]: cartViewLocation.PDP_TOP_NAV,
      [locationPathname.SLP]: cartViewLocation.SLP_TOP_NAV,
      [locationPathname.WISHLIST]: cartViewLocation.WISHLIST_PAGE_TOP_NAV,
      [locationPathname.NLP]: cartViewLocation.NLP_TOP_NAV,
      [locationPathname.HLP]: cartViewLocation.HLP_TOP_NAV,
    },
    cartViewLocation.OTHER_PAGE
  );

export const getViewBagPageSource = () =>
  getPageSource(
    {
      [locationPathname.PLP]: cartViewLocation.PLP_VIEW_BAG,
      [locationPathname.PDP]: cartViewLocation.PDP_VIEW_BAG,
      [locationPathname.SLP]: cartViewLocation.SLP_VIEW_BAG,
      [locationPathname.WISHLIST]: cartViewLocation.WISHLIST_VIEW_BAG,
      [locationPathname.NLP]: cartViewLocation.NLP_VIEW_BAG,
      [locationPathname.HLP]: cartViewLocation.HLP_VIEW_BAG,
    },
    cartViewLocation.OTHER_PAGE
  );
